<template>
   <section
      class="hc-scroll-door js-scroll-door is-animated"
      aria-label="Every Job Makes The Stay"
    >
       <div
        class="hc-scroll-door__left js-scroll-door-left"
        style="animation-duration: 5s"
      >
        <p class="hc-scroll-door__text" aria-hidden="true" inert="">
          <span>Every Job&nbsp;</span><span>Every Job&nbsp;</span
          ><span>Every Job&nbsp;</span><span>Every Job&nbsp;</span
          ><span>Every Job&nbsp;</span><span>Every Job&nbsp;</span
          ><span>Every Job&nbsp;</span><span>Every Job&nbsp;</span
          ><span>Every Job&nbsp;</span><span>Every Job&nbsp;</span>
        </p>
      </div>
      <div
        class="hc-scroll-door__right js-scroll-door-right"
        style="animation-duration: 7.88011s"
      >
        <p class="hc-scroll-door__text" aria-hidden="true" inert="">
          <span>Makes The Stay&nbsp;</span><span>Makes The Stay&nbsp;</span
          ><span>Makes The Stay&nbsp;</span><span>Makes The Stay&nbsp;</span
          ><span>Makes The Stay&nbsp;</span><span>Makes The Stay&nbsp;</span
          ><span>Makes The Stay&nbsp;</span><span>Makes The Stay&nbsp;</span
          ><span>Makes The Stay&nbsp;</span><span>Makes The Stay&nbsp;</span>
        </p>
      </div>
   </section>
</template>

<script setup>

</script>